import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ConnectWithUs from "./sections/ConnectWithUs";
import ServiceMap from "./sections/ServiceMap";
import HeroContact from "./sections/HeroContact";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <HeroContact />
      <ConnectWithUs />
      <ServiceMap />
      <Footer />
    </div>;
}